// Bono de la promo de crédito en la cotización: lo que se cotiza es lo que se paga al activar.
import { Gift } from 'lucide-react';
import { formatMXN } from '@/shared/lib/format/money';
import { PromoChip } from './PromoChip';

export function QuoteBonusNote({ bonusCents }: { bonusCents: number | undefined }) {
    if (bonusCents === undefined || bonusCents <= 0) return null;
    return (
        <div className="flex justify-end pt-1.5">
            <PromoChip size="md" icon={Gift}>
                Bono de {formatMXN(bonusCents / 100)} a tu cuenta
            </PromoChip>
        </div>
    );
}
